/**
 * UI strings. English now; Telugu and Hindi are added by filling in more
 * dictionaries with the same keys — screens call t('key') and never hard-code
 * text that cashiers read.
 */
const en = {
  'nav.dashboard': 'Dashboard', 'nav.billing': 'Billing', 'nav.products': 'Products', 'nav.stock': 'Stock',
  'nav.labels': 'Barcode labels', 'nav.sales': 'Sales history', 'nav.counters': 'Counters', 'nav.users': 'Users',
  'nav.reports': 'Reports', 'nav.settings': 'Settings', 'nav.subscription': 'Subscription',
  'bill.scan': 'Scan barcode or type name / brand / size', 'bill.empty': 'Scan or search an item to start the bill',
  'bill.total': 'Total', 'bill.items': 'Items', 'bill.pay': 'Pay', 'bill.complete': 'Complete bill',
  'bill.hold': 'Hold', 'bill.held': 'Held bills', 'bill.clear': 'Clear', 'bill.discount': 'Bill discount',
  'bill.cash': 'Cash', 'bill.card': 'Card', 'bill.upi': 'UPI', 'bill.split': 'Split', 'bill.received': 'Cash received',
  'bill.change': 'Change to return', 'bill.done': 'Bill saved', 'bill.notFound': 'Product not found',
  'bill.notFoundCashier': 'Product not found – ask manager', 'bill.short': 'Not enough stock',
  'bill.reprint': 'Reprint last bill', 'bill.newBill': 'New bill',
  'common.save': 'Save', 'common.cancel': 'Cancel', 'common.close': 'Close', 'common.search': 'Search',
  'common.print': 'Print', 'common.export': 'Export', 'common.loading': 'Loading…', 'common.signOut': 'Sign out',
} as const;

export type I18nKey = keyof typeof en;
type Dict = Partial<Record<I18nKey, string>>;

const dictionaries: Record<string, Dict> = { en, te: {}, hi: {} };
let current = localStorage.getItem('zpos_lang') || 'en';

export function setLanguage(lang: string) {
  current = dictionaries[lang] ? lang : 'en';
  localStorage.setItem('zpos_lang', current);
}

export function t(key: I18nKey): string {
  return dictionaries[current]?.[key] || en[key] || key;
}
